module.exports = __webpack_public_path__ + "static/media/m1_sf_17.c07948f9.png";